"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 13 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M2.29175 0.387695L3.71997 1.19336C3.2561 2.12109 2.94482 2.84741 2.78613 3.37231C2.62744 3.89722 2.50537 4.57471 2.41992 5.40479H4.04956V10.4402H0.735352V7.29077C0.735352 5.71606 0.839111 4.48315 1.04663 3.59204C1.26636 2.68872 1.6814 1.62061 2.29175 0.387695ZM10.4399 0.387695L11.8682 1.19336C11.4043 2.12109 11.093 2.84741 10.9343 3.37231C10.7756 3.89722 10.6536 4.57471 10.5681 5.40479H12.1978V10.4402H8.88354V7.29077C8.88354 5.71606 8.9873 4.48315 9.19482 3.59204C9.40234 2.68872 9.81738 1.62061 10.4399 0.387695Z",
      fill: "currentColor"
    })
  });
};

exports.default = Icon;